import { AuthGuard } from '../../../shared/services';
import { DocumentsMecenatComponent } from './document_mecenat.component';
import { Route } from '@angular/router';

export const DocumentsMecenatRoutes: Route[] = [
  {
    path: 'mecenat',
    component: DocumentsMecenatComponent,
    canActivate: [AuthGuard]
  }
];
